<template>
  <div v-if="breadcrumbs.length" class="page-header">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item,i) in breadcrumbs" :key="i" :to="i!==breadcrumbs.length-1 ? { path:item.path } : undefined">
        {{ item.meta.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <slot name="extra" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// 过滤出有标题的 matched 路由作为面包屑
const breadcrumbs = computed(() => {
  return route.matched.filter(r => r.meta && r.meta.title && !r.meta.hideInBreadcrumb)
})
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
}
</style> 